let viewgird = [
  //
  // ----------
  // 系统相关
  {
    path: '/Sys_Log',
    name: 'sys_Log',
    component: () => import('@/views/system/Sys_Log.vue')
  },
  {
    path: '/Sys_User',
    name: 'Sys_User',
    component: () => import('@/views/system/Sys_User.vue')
  },
  {
    path: '/permission',
    name: 'permission',
    component: () => import('@/views/system/Permission.vue')
  },

  {
    path: '/Sys_Dictionary',
    name: 'Sys_Dictionary',
    component: () => import('@/views/system/Sys_Dictionary.vue')
  },
  {
    path: '/Sys_Role',
    name: 'Sys_Role',
    component: () => import('@/views/system/Sys_Role.vue')
  },
  {
    path: '/Sys_Role1',
    name: 'Sys_Role1',
    component: () => import('@/views/system/Sys_Role1.vue')
  },
  {
    path: '/Sys_DictionaryList',
    name: 'Sys_DictionaryList',
    component: () => import('@/views/system/Sys_DictionaryList.vue')
  },
  {
    path: '/FormDesignOptions',
    name: 'FormDesignOptions',
    component: () => import('@/views/system/form/FormDesignOptions.vue')
  },
  {
    path: '/FormCollectionObject',
    name: 'FormCollectionObject',
    component: () => import('@/views/system/form/FormCollectionObject.vue')
  },
  {
    path: '/Sys_WorkFlow',
    name: 'Sys_WorkFlow',
    component: () => import('@/views/system/flow/Sys_WorkFlow.vue')
  },
  {
    path: '/Sys_WorkFlowTable',
    name: 'Sys_WorkFlowTable',
    component: () => import('@/views/system/flow/Sys_WorkFlowTable.vue')
  },
  {
    path: '/Sys_QuartzOptions',
    name: 'Sys_QuartzOptions',
    component: () => import('@/views/system/quartz/Sys_QuartzOptions.vue')
  },
  {
    path: '/Sys_QuartzLog',
    name: 'Sys_QuartzLog',
    component: () => import('@/views/system/quartz/Sys_QuartzLog.vue')
  },
  {
    path: '/Sys_Department',
    name: 'Sys_Department',
    component: () => import('@/views/system/system/Sys_Department.vue')
  },
  // ?
  {
    path: '/Dev_Message',
    name: 'Dev_Message',
    component: () => import('@/views/system/message/Dev_Message.vue')
  },
  //
  // ----------
  // method
  //
  {
    path: '/MetAssetGroup',
    name: 'MetAssetGroup',
    component: () => import('@/views/method/method/MetAssetGroup.vue')
  },
  {
    path: '/MetFormConfig',
    name: 'MetFormConfig',
    component: () => import('@/views/method/method/MetFormConfig.vue')
  },
  {
    path: '/MetCompMenu',
    name: 'MetCompMenu',
    component: () => import('@/views/method/method/MetCompMenu.vue')
  },
  {
    path: '/MetMessageGroup',
    name: 'MetMessageGroup',
    component: () => import('@/views/method/message/MetMessageGroup.vue')
  },
  {
    path: '/MetMessageLog',
    name: 'MetMessageLog',
    component: () => import('@/views/method/message/MetMessageLog.vue')
  },
  {
    path: '/MetMessage',
    name: 'MetMessage',
    component: () => import('@/views/method/message/MetMessage.vue')
  },
  {
    path: '/MetMessageGroupUser',
    name: 'MetMessageGroupUser',
    component: () => import('@/views/method/message/MetMessageGroupUser.vue')
  },
  //
  // ----------
  // 设备相关
  {
    path: '/Device',
    name: 'Device',
    component: () => import('@/views/device/device/Device.vue')
  },
  {
    path: '/Dev_ConnectCompDevice',
    name: 'Dev_ConnectCompDevice',
    component: () => import('@/views/device/device/Dev_ConnectCompDevice.vue')
  },
  {
    path: '/Dev_Device',
    name: 'Dev_Device',
    component: () => import('@/views/device/device/Dev_Device.vue')
  },
  {
    path: '/Dev_DeviceDetail',
    name: 'Dev_DeviceDetail',
    component: () => import('@/views/device/device/Dev_DeviceDetail.vue')
  },
  {
    path: '/Dev_TelemetryGroup',
    name: 'Dev_TelemetryGroup',
    component: () => import('@/views/device/device/Dev_TelemetryGroup.vue')
  },
  {
    path: '/Dev_TelemetryGroupDetail',
    name: 'Dev_TelemetryGroupDetail',
    component: () => import('@/views/device/device/Dev_TelemetryGroupDetail.vue')
  },
  {
    path: '/Dev_DeviceType',
    name: 'Dev_DeviceType',
    component: () => import('@/views/device/device/Dev_DeviceType.vue')
  },
  {
    path: '/Dev_DeviceAlarmMsg',
    name: 'Dev_DeviceAlarmMsg',
    component: () => import('@/views/device/device/Dev_DeviceAlarmMsg.vue')
  },
  {
    path: '/Dev_Company',
    name: 'Dev_Company',
    component: () => import('@/views/device/device/Dev_Company.vue')
  },
  {
    path: '/Dev_UserRole',
    name: 'Dev_UserRole',
    component: () => import('@/views/device/device/Dev_UserRole.vue')
  },
  {
    path: '/Dev_RoleDeviceAuth',
    name: 'Dev_RoleDeviceAuth',
    component: () => import('@/views/device/device/Dev_RoleDeviceAuth.vue')
  },
  {
    path: '/Dev_FaultInfo',
    name: 'Dev_FaultInfo',
    component: () => import('@/views/device/device/Dev_FaultInfo.vue')
  },
  //
  // ----------
  // 点巡检
  {
    path: '/Dev_PointTmp',
    name: 'Dev_PointTmp',
    component: () => import('@/views/device/inspection/Dev_PointTmp.vue')
  },
  {
    path: '/Dev_PointInspection',
    name: 'Dev_PointInspection',
    component: () => import('@/views/device/inspection/Dev_PointInspection.vue')
  },
  {
    path: '/Dev_PointDetail',
    name: 'Dev_PointDetail',
    component: () => import('@/views/device/inspection/Dev_PointDetail.vue')
  },
  {
    path: '/Dev_PointView',
    name: 'Dev_PointView',
    component: () => import('@/views/device/inspection/Dev_PointView.vue')
  },
  {
    path: '/Dev_PointAudit',
    name: 'Dev_PointAudit',
    component: () => import('@/views/device/inspection/Dev_PointAudit.vue')
  },
  {
    path: '/Dev_PointConfig',
    name: 'Dev_PointConfig',
    component: () => import('@/views/device/inspection/Dev_PointConfig.vue')
  },
  {
    path: '/Dev_PointConfigDet',
    name: 'Dev_PointConfigDet',
    component: () => import('@/views/device/inspection/Dev_PointConfigDet.vue')
  },
  {
    path: '/Dev_PointTmpDet',
    name: 'Dev_PointTmpDet',
    component: () => import('@/views/device/inspection/Dev_PointTmpDet.vue')
  },
  {
    path: '/Dev_RoutineInspection',
    name: 'Dev_RoutineInspection',
    component: () => import('@/views/device/inspection/Dev_RoutineInspection.vue')
  },
  {
    path: '/Dev_RoutineDetail',
    name: 'Dev_RoutineDetail',
    component: () => import('@/views/device/inspection/Dev_RoutineDetail.vue')
  },
  {
    path: '/Dev_RoutineView',
    name: 'Dev_RoutineView',
    component: () => import('@/views/device/inspection/Dev_RoutineView.vue')
  },
  {
    path: '/Dev_RoutineAudit',
    name: 'Dev_RoutineAudit',
    component: () => import('@/views/device/inspection/Dev_RoutineAudit.vue')
  },
  {
    path: '/Dev_RoutineTmp',
    name: 'Dev_RoutineTmp',
    component: () => import('@/views/device/inspection/Dev_RoutineTmp.vue')
  },
  {
    path: '/Dev_RoutineTmpDet',
    name: 'Dev_RoutineTmpDet',
    component: () => import('@/views/device/inspection/Dev_RoutineTmpDet.vue')
  },
  {
    path: '/Dev_RoutineConfig',
    name: 'Dev_RoutineConfig',
    component: () => import('@/views/device/inspection/Dev_RoutineConfig.vue')
  },
  {
    path: '/Dev_RoutineConfigDet',
    name: 'Dev_RoutineConfigDet',
    component: () => import('@/views/device/inspection/Dev_RoutineConfigDet.vue')
  },
  {
    path: '/Dev_RoleDeviceAuthTree',
    name: 'Dev_RoleDeviceAuthTree',
    component: () => import('@/views/device/Dev_RoleDeviceAuthTree.vue')
  },
  //
  // ----------
  // 备件管理
  {
    path: '/Dev_Materials',
    name: 'Dev_Materials',
    component: () => import('@/views/device/sparepartsmanagement/Dev_Materials.vue')
  },
  {
    path: '/Dev_MaterialApplicationApproval_Log',
    name: 'Dev_MaterialApplicationApproval_Log',
    component: () => import('@/views/device/sparepartsmanagement/Dev_MaterialApplicationApproval_Log.vue')
  },
  {
    path: '/Dev_MaterialApproval_Log',
    name: 'Dev_MaterialApproval_Log',
    component: () => import('@/views/device/sparepartsmanagement/Dev_MaterialApproval_Log.vue')
  },
  {
    path: '/Dev_MaterialInOut_Log',
    name: 'Dev_MaterialInOut_Log',
    component: () => import('@/views/device/sparepartsmanagement/Dev_MaterialInOut_Log.vue')
  },
  //
  // ----------
  // 维修管理
  {
    path: '/Dev_ConnectRepairDevice',
    name: 'Dev_ConnectRepairDevice',
    component: () => import('@/views/device/maintenancemanagement/Dev_ConnectRepairDevice.vue')
  },
  {
    path: '/Dev_DeviceRePairRequestForm',
    name: 'Dev_DeviceRePairRequestForm',
    component: () => import('@/views/device/maintenancemanagement/Dev_DeviceRePairRequestForm.vue')
  },
  {
    path: '/Dev_DeviceRePairApprove',
    name: 'Dev_DeviceRePairApprove',
    component: () => import('@/views/device/maintenancemanagement/Dev_DeviceRePairApprove.vue')
  },
  {
    path: '/Dev_DeviceRePairLog',
    name: 'Dev_DeviceRePairLog',
    component: () => import('@/views/device/maintenancemanagement/Dev_DeviceRePairLog.vue')
  },
  {
    path: '/Dev_PersonalCalendar',
    name: 'Dev_PersonalCalendar',
    component: () => import('@/views/device/maintenancemanagement/Dev_PersonalCalendar.vue')
  },
  //
  // ----------
  // 保养
  {
    path: '/Dev_MaintainDetailedList',
    name: 'Dev_MaintainDetailedList',
    component: () => import('@/views/device/maintainmanage/Dev_MaintainDetailedList.vue')
  },
  {
    path: '/Dev_MaintainPlan',
    name: 'Dev_MaintainPlan',
    component: () => import('@/views/device/maintainmanage/Dev_MaintainPlan.vue')
  },
  {
    path: '/Dev_MaintainTask',
    name: 'Dev_MaintainTask',
    component: () => import('@/views/device/maintainmanage/Dev_MaintainTask.vue')
  },
  {
    path: '/Dev_MaintainTaskLog',
    name: 'Dev_MaintainTaskLog',
    component: () => import('@/views/device/maintainmanage/Dev_MaintainTaskLog.vue')
  },
  {
    path: '/Dev_MaintainTemplate',
    name: 'Dev_MaintainTemplate',
    component: () => import('@/views/device/maintainmanage/Dev_MaintainTemplate.vue')
  },
  //
  // ----------
  // 消息管理
  {
    path: '/Dev_MessageLog',
    name: 'Dev_MessageLog',
    component: () => import('@/views/device/message/Dev_MessageLog.vue')
  },
  {
    path: '/Dev_MessageGroup',
    name: 'Dev_MessageGroup',
    component: () => import('@/views/device/message/Dev_MessageGroup.vue')
  },
  {
    path: '/Dev_MessageGroupUser',
    name: 'Dev_MessageGroupUser',
    component: () => import('@/views/device/message/Dev_MessageGroupUser.vue')
  },
  //
  // ----------
  // 报警
  {
    path: '/alarmlist',
    name: 'alarmlist',
    component: () => import('@/views/device/alarm/alarmlist.vue')
  },
  {
    path: '/Dev_Alarm',
    name: 'Dev_Alarm',
    component: () => import('@/views/device/alarm/Dev_Alarm.vue')
  },
  {
    path: '/Dev_AlarmLatest',
    name: 'Dev_AlarmLatest',
    component: () => import('@/views/device/alarm/Dev_AlarmLatest.vue')
  },
  {
    path: '/Dev_AlarmHistory',
    name: 'Dev_AlarmHistory',
    component: () => import('@/views/device/alarm/Dev_AlarmHistory.vue')
  },
  {
    path: '/Dev_AlarmMessage',
    name: 'Dev_AlarmMessage',
    component: () => import('@/views/device/alarm/Dev_AlarmMessage.vue')
  },
  {
    path: '/Dev_AlarmRuleEvent',
    name: 'Dev_AlarmRuleEvent',
    component: () => import('@/views/device/alarm/Dev_AlarmRuleEvent.vue')
  },
  {
    path: '/Dev_AlarmRule',
    name: 'Dev_AlarmRule',
    component: () => import('@/views/device/alarm/Dev_AlarmRule.vue')
  },
  {
    path: '/Dev_AlarmDetail',
    name: 'Dev_AlarmDetail',
    component: () => import('@/views/device/alarm/Dev_AlarmDetail.vue')
  },
  {
    path: '/Dev_AlarmList',
    name: 'Dev_AlarmList',
    component: () => import('@/views/device/alarm/Dev_AlarmList.vue')
  },
  //
  // ----------
  // 能源管理
  {
    path: '/Dev_Substation',
    name: 'Dev_Substation',
    component: () => import('@/views/device/energy/Dev_Substation.vue')
  },
  {
    path: '/Dev_EnergyStorage',
    name: 'Dev_EnergyStorage',
    component: () => import('@/views/device/energy/Dev_EnergyStorage.vue')
  },
  {
    path: '/Dev_LineGraph',
    name: 'Dev_LineGraph',
    component: () => import('@/views/device/energy/Dev_LineGraph.vue')
  },
  {
    path: '/Dev_LineGraphView',
    name: 'Dev_LineGraphView',
    component: () => import('@/views/device/energy/Dev_LineGraphView.vue')
  },
  {
    path: '/Dev_PowerDiagramX6',
    name: 'Dev_PowerDiagramX6',
    component: () => import('@/views/device/energy/Dev_PowerDiagramX6.vue')
  },
  {
    path: '/Dev_TreeTemplate',
    name: 'Dev_TreeTemplate',
    component: () => import('@/views/device/energy/Dev_TreeTemplate.vue')
  },

  {
    path: '/Dev_HarmonicDetection',
    name: 'Dev_HarmonicDetection',
    component: () => import('@/views/device/energy/Dev_HarmonicDetection.vue')
  },
  {
    path: '/Dev_EnergyFlow',
    name: 'Dev_EnergyFlow',
    component: () => import('@/views/device/energy/Dev_EnergyFlow.vue')
  },
  {
    path: '/Dev_ThreePhaseUnbalanceAngle',
    name: 'Dev_ThreePhaseUnbalanceAngle',
    component: () => import('@/views/device/energy/Dev_ThreePhaseUnbalanceAngle.vue')
  },
  {
    path: '/Dev_ThreePhaseUnbalanceRate',
    name: 'Dev_ThreePhaseUnbalanceRate',
    component: () => import('@/views/device/energy/Dev_ThreePhaseUnbalanceRate.vue')
  },
  {
    path: '/Dev_DeviceEnergy',
    name: 'Dev_DeviceEnergy',
    component: () => import('@/views/device/energy/Dev_DeviceEnergy.vue')
  },
  {
    path: '/Dev_MeterReadingView',
    name: 'Dev_MeterReadingView',
    component: () => import('@/views/device/energy/Dev_MeterReadingView.vue')
  },
  {
    path: '/Dev_DevicePointSet',
    name: 'Dev_DevicePointSet',
    component: () => import('@/views/device/energy/Dev_DevicePointSet.vue')
  },
  {
    path: '/Dev_DevicePointEnergyLog',
    name: 'Dev_DevicePointEnergyLog',
    component: () => import('@/views/device/energy/Dev_DevicePointEnergyLog.vue')
  },
  {
    path: '/Dev_DeviceEnergyChart',
    name: 'Dev_DeviceEnergyChart',
    component: () => import('@/views/device/energy/Dev_DeviceEnergyChart.vue')
  },
  {
    path: '/Dev_DevicePointEnergyChart',
    name: 'Dev_DevicePointEnergyChart',
    component: () => import('@/views/device/energy/Dev_DevicePointEnergyChart.vue')
  },
  {
    path: '/Dev_Environment',
    name: 'Dev_Environment',
    component: () => import('@/views/device/energy/Dev_Environment.vue')
  },
  {
    path: '/Dev_EnergyReport',
    name: 'Dev_EnergyReport',
    component: () => import('@/views/device/energy/Dev_EnergyReport.vue')
  },
  {
    path: '/Dev_DrawIO',
    name: 'Dev_DrawIO',
    component: () => import('@/views/device/energy/Dev_DrawIO.vue'),
    meta: {
      // 页面不缓存，每次刷新都重新加载
      // true 缓存，每次刷新都从缓存中获取
      keepAlive: false
    }
  },
  {
    path: '/Dev_DeviceLoad',
    name: 'Dev_DeviceLoad',
    component: () => import('@/views/device/energy/Dev_DeviceLoad.vue')
  },
  {
    path: '/Dev_DeviceLoadChart',
    name: 'Dev_DeviceLoadChart',
    component: () => import('@/views/device/energy/Dev_DeviceLoadChart.vue')
  },
  {
    path: '/Dev_DeviceFhChart',
    name: 'Dev_DeviceFhChart',
    component: () => import('@/views/device/energy/Dev_DeviceFhChart.vue')
  },
  {
    path: '/Dev_DeviceRealTimeChart',
    name: 'Dev_DeviceRealTimeChart',
    component: () => import('@/views/device/energy/Dev_DeviceRealTimeChart.vue')
  },
  {
    path: '/Dev_DevicePointEnergyLogDataProcessing',
    name: 'Dev_DevicePointEnergyLogDataProcessing',
    component: () => import('@/views/device/energy/Dev_DevicePointEnergyLogDataProcessing.vue')
  },
  {
    path: '/Dev_DeviceMultiComparison',
    name: 'Dev_DeviceMultiComparison',
    component: () => import('@/views/device/energy/Dev_DeviceMultiComparison.vue')
  },
  {
    path: '/Dashboard_Substation',
    name: 'Dashboard_Substation',
    component: () => import('@/views/device/energy/Dashboard/Dashboard_Substation.vue')
  },
  {
    path: '/Dev_EnergyProperty',
    name: 'Dev_EnergyProperty',
    component: () => import('@/views/device/energy/Dev_EnergyProperty.vue')
  },
  {
    path: '/UnitMonitor',
    name: 'UnitMonitor',
    component: () => import('@/views/device/energy/Dashboard/UnitMonitor.vue')
  },
  {
    path: '/Ene_EnergyTcp',
    name: 'Ene_EnergyTcp',
    component: () => import('@/views/device/energy/Ene_EnergyTcp.vue')
  },
  {
    path: '/Ene_EnergyTcpLog',
    name: 'Ene_EnergyTcpLog',
    component: () => import('@/views/device/energy/Ene_EnergyTcpLog.vue')
  },
  {
    path: '/Dev_SubstationDevice',
    name: 'Dev_SubstationDevice',
    component: () => import('@/views/device/energy/Dev_SubstationDevice.vue')
  },
  {
    path: '/Dev_EnergyStorageDevice',
    name: 'Dev_EnergyStorageDevice',
    component: () => import('@/views/device/energy/Dev_EnergyStorageDevice.vue')
  },
  {
    path: '/Ene_ACControl',
    name: 'Ene_ACControl',
    component: () => import('@/views/device/energy/Ene_ACControl.vue')
  },
  {
    path: '/Ene_BoilerControl',
    name: 'Ene_BoilerControl',
    component: () => import('@/views/device/energy/Ene_BoilerControl.vue')
  },
  // 能源管理
  // ----------
  // ? 总览
  // ? 电能监控
  // ? 变压器监控
  // ? 运营效率监控
  {
    path: '/overview',
    name: 'overview',
    component: () => import('@/views/Ene/PowerStationMonitoring/overview.vue')
  },
  {
    path: '/electricalMonitoring',
    name: 'electricalMonitoring',
    component: () => import('@/views/Ene/PowerStationMonitoring/electricalMonitoring.vue')
  },
  {
    path: '/transformerMonitoring',
    name: 'transformerMonitoring',
    component: () => import('@/views/Ene/PowerStationMonitoring/transformerMonitoring.vue')
  },
  {
    path: '/operationalEnergyEfficiency',
    name: 'operationalEnergyEfficiency',
    component: () => import('@/views/Ene/PowerStationMonitoring/operationalEnergyEfficiency.vue')
  },
  //
  // ----------
  // 环保管理
  {
    path: '/Eco_Overview',
    name: 'Eco_Overview',
    component: () => import('@/views/device/eco/Eco_Overview.vue')
  },
  {
    path: '/Eco_UsingWater',
    name: 'Eco_UsingWater',
    component: () => import('@/views/device/eco/Eco_UsingWater.vue')
  },
  {
    path: '/Eco_Wastewater',
    name: 'Eco_Wastewater',
    component: () => import('@/views/device/eco/Eco_Wastewater.vue')
  },
  {
    path: '/Eco_GeneralWaste',
    name: 'Eco_GeneralWaste',
    component: () => import('@/views/device/eco/Eco_GeneralWaste.vue')
  },
  {
    path: '/Eco_HazardousWaste',
    name: 'Eco_HazardousWaste',
    component: () => import('@/views/device/eco/Eco_HazardousWaste.vue')
  },
  {
    path: '/Eco_ExhaustWaste',
    name: 'Eco_ExhaustWaste',
    component: () => import('@/views/device/eco/Eco_ExhaustWaste.vue')
  },

  // 生产工况
  {
    path: '/Eco_ProductionMonitoring',
    name: 'Eco_ProductionMonitoring',
    component: () => import('@/views/device/eco/Eco_ProductionMonitoring.vue')
  },
  // 治污工况
  {
    path: '/Eco_PollutionControl',
    name: 'Eco_PollutionControl',
    component: () => import('@/views/device/eco/Eco_PollutionControl.vue')
  },
  {
    path: '/Eco_DeviceView',
    name: 'Eco_DeviceView',
    component: () => import('@/views/device/eco/Eco_DeviceView.vue')
  },
  {
    path: '/Eco_VideoView',
    name: 'Eco_VideoView',
    component: () => import('@/views/device/eco/Eco_VideoView.vue')
  },
  {
    path: '/Eco_RainwaterView',
    name: 'Eco_RainwaterView',
    component: () => import('@/views/device/eco/Eco_RainwaterView.vue')
  },
  {
    path: '/Eco_RainwaterView2',
    name: 'Eco_RainwaterView2',
    component: () => import('@/views/device/eco/Eco_RainwaterView2.vue')
  },
  {
    path: '/Eco_Factory',
    name: 'Eco_Factory',
    component: () => import('@/views/device/eco/Eco_Factory.vue')
  },
  {
    path: '/Eco_Ledger',
    name: 'Eco_Ledger',
    component: () => import('@/views/device/eco/Eco_Ledger.vue')
  },
  {
    path: '/Eco_Class',
    name: 'Eco_Class',
    component: () => import('@/views/device/eco/Eco_Class.vue')
  },
  {
    path: '/Eco_WasteLimit',
    name: 'Eco_WasteLimit',
    component: () => import('@/views/device/eco/Eco_WasteLimit.vue')
  },
  {
    path: '/Eco_EmissionLimit',
    name: 'Eco_EmissionLimit',
    component: () => import('@/views/device/eco/Eco_EmissionLimit.vue')
  },
  {
    path: '/Eco_ReceiveUnit',
    name: 'Eco_ReceiveUnit',
    component: () => import('@/views/device/eco/Eco_ReceiveUnit.vue')
  },
  {
    path: '/Eco_NationalWasteList',
    name: 'Eco_NationalWasteList',
    component: () => import('@/views/device/eco/Eco_NationalWasteList.vue')
  },
  {
    path: '/Eco_WasteWarehouse',
    name: 'Eco_WasteWarehouse',
    component: () => import('@/views/device/eco/Eco_WasteWarehouse.vue')
  },
  {
    path: '/Eco_WasteLists',
    name: 'Eco_WasteLists',
    component: () => import('@/views/device/eco/Eco_WasteLists.vue')
  },
  {
    path: '/Eco_WasteInLog',
    name: 'Eco_WasteInLog',
    component: () => import('@/views/device/eco/Eco_WasteInLog.vue')
  },
  {
    path: '/Eco_WasteOutLog',
    name: 'Eco_WasteOutLog',
    component: () => import('@/views/device/eco/Eco_WasteOutLog.vue')
  },
  {
    path: '/Eco_RubbishInLog',
    name: 'Eco_RubbishInLog',
    component: () => import('@/views/device/eco/Eco_RubbishInLog.vue')
  },
  {
    path: '/Eco_RubbishWarehouse',
    name: 'Eco_RubbishWarehouse',
    component: () => import('@/views/device/eco/Eco_RubbishWarehouse.vue')
  },
  {
    path: '/Eco_Rubbish',
    name: 'Eco_Rubbish',
    component: () => import('@/views/device/eco/Eco_Rubbish.vue')
  },
  {
    path: '/Eco_RubbishList',
    name: 'Eco_RubbishList',
    component: () => import('@/views/device/eco/Eco_RubbishList.vue')
  },
  {
    path: '/Eco_RubbishOutLog',
    name: 'Eco_RubbishOutLog',
    component: () => import('@/views/device/eco/Eco_RubbishOutLog.vue')
  },
  {
    path: '/Eco_Permits',
    name: 'Eco_Permits',
    component: () => import('@/views/device/eco/Eco_Permits.vue')
  },
  {
    path: '/Dev_SwitchDevice',
    name: 'Dev_SwitchDevice',
    component: () => import('@/views/device/device/Dev_SwitchDevice.vue')
  },
  {
    path: '/Dev_SwitchLog',
    name: 'Dev_SwitchLog',
    component: () => import('@/views/device/device/Dev_SwitchLog.vue')
  },
  {
    path: '/Dev_SwitchEventLog',
    name: 'Dev_SwitchEventLog',
    component: () => import('@/views/device/device/Dev_SwitchEventLog.vue')
  },
  {
    path: '/Ene_BoilerMaintain',
    name: 'Ene_BoilerMaintain',
    component: () => import('@/views/device/energy/Ene_BoilerMaintain.vue')
  },
  {
    path: '/Ene_BoilerControlView',
    name: 'Ene_BoilerControlView',
    component: () => import('@/views/device/energy/Ene_BoilerControlView.vue')
  },
  
  {
    path: '/Ene_BoilerControlConfig',
    name: 'Ene_BoilerControlConfig',
    component: () => import('@/views/device/energy/Ene_BoilerControlConfig.vue')
  },
  {
    path: '/Ene_HolidayMaintain',
    name: 'Ene_HolidayMaintain',
    component: () => import('@/views/device/energy/Ene_HolidayMaintain.vue')
  },
  {
    path: '/Ene_DeviceControllerLog',
    name: 'Ene_DeviceControllerLog',
    component: () => import('@/views/device/energy/Ene_DeviceControllerLog.vue')
  },
  {
    path: '/Ene_ACMaintain',
    name: 'Ene_ACMaintain',
    component: () => import('@/views/device/energy/Ene_ACMaintain.vue')
  },
  {
    path: '/Ene_ACGlobalConfig',
    name: 'Ene_ACGlobalConfig',
    component: () => import('@/views/device/energy/Ene_ACGlobalConfig.vue')
  },
  {
    path: '/Sys_Tenant',
    name: 'Sys_Tenant',
    component: () => import('@/views/sys/system/Sys_Tenant.vue')
  },
  {
    path: '/Sys_DbService',
    name: 'Sys_DbService',
    component: () => import('@/views/sys/system/Sys_DbService.vue')
  },
  {
    path: '/Dev_Tmp',
    name: 'Dev_Tmp',
    component: () => import('@/views/device/device/Dev_Tmp.vue')
  },
  {
    path: '/Dev_DeviceLedger',
    name: 'Dev_DeviceLedger',
    component: () => import('@/views/device/device/deviceman/Dev_DeviceLedger.vue')
  },
];

export default viewgird;
